/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateAssetCustomFieldValueResponseDto,
  CreateAssetScopedCustomFieldValueRequestDto,
  FindAssetCustomFieldValueResponseDto,
  UpdateAssetCustomFieldValueRequestDto,
} from '../models/index';
import {
    CreateAssetCustomFieldValueResponseDtoFromJSON,
    CreateAssetCustomFieldValueResponseDtoToJSON,
    CreateAssetScopedCustomFieldValueRequestDtoFromJSON,
    CreateAssetScopedCustomFieldValueRequestDtoToJSON,
    FindAssetCustomFieldValueResponseDtoFromJSON,
    FindAssetCustomFieldValueResponseDtoToJSON,
    UpdateAssetCustomFieldValueRequestDtoFromJSON,
    UpdateAssetCustomFieldValueRequestDtoToJSON,
} from '../models/index';

export interface AssetCustomFieldValuesByAssetControllerCreateRequest {
    assetId: string;
    organizationId: string;
    createAssetScopedCustomFieldValueRequestDto: CreateAssetScopedCustomFieldValueRequestDto;
}

export interface AssetCustomFieldValuesByAssetControllerDeleteRequest {
    valueId: string;
    assetId: string;
    organizationId: string;
}

export interface AssetCustomFieldValuesByAssetControllerGetByAssetRequest {
    assetId: string;
    organizationId: string;
}

export interface AssetCustomFieldValuesByAssetControllerGetByIdRequest {
    valueId: string;
    assetId: string;
    organizationId: string;
}

export interface AssetCustomFieldValuesByAssetControllerUpdateRequest {
    valueId: string;
    assetId: string;
    organizationId: string;
    updateAssetCustomFieldValueRequestDto: UpdateAssetCustomFieldValueRequestDto;
}

/**
 * 
 */
export class AssetCustomFieldValuesApi extends runtime.BaseAPI {

    /**
     */
    async assetCustomFieldValuesByAssetControllerCreateRaw(requestParameters: AssetCustomFieldValuesByAssetControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateAssetCustomFieldValueResponseDto>> {
        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling assetCustomFieldValuesByAssetControllerCreate().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling assetCustomFieldValuesByAssetControllerCreate().'
            );
        }

        if (requestParameters['createAssetScopedCustomFieldValueRequestDto'] == null) {
            throw new runtime.RequiredError(
                'createAssetScopedCustomFieldValueRequestDto',
                'Required parameter "createAssetScopedCustomFieldValueRequestDto" was null or undefined when calling assetCustomFieldValuesByAssetControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/assets/{assetId}/custom-field-values`;
        urlPath = urlPath.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters['assetId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateAssetScopedCustomFieldValueRequestDtoToJSON(requestParameters['createAssetScopedCustomFieldValueRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateAssetCustomFieldValueResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async assetCustomFieldValuesByAssetControllerCreate(requestParameters: AssetCustomFieldValuesByAssetControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateAssetCustomFieldValueResponseDto> {
        const response = await this.assetCustomFieldValuesByAssetControllerCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async assetCustomFieldValuesByAssetControllerDeleteRaw(requestParameters: AssetCustomFieldValuesByAssetControllerDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['valueId'] == null) {
            throw new runtime.RequiredError(
                'valueId',
                'Required parameter "valueId" was null or undefined when calling assetCustomFieldValuesByAssetControllerDelete().'
            );
        }

        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling assetCustomFieldValuesByAssetControllerDelete().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling assetCustomFieldValuesByAssetControllerDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/assets/{assetId}/custom-field-values/{valueId}`;
        urlPath = urlPath.replace(`{${"valueId"}}`, encodeURIComponent(String(requestParameters['valueId'])));
        urlPath = urlPath.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters['assetId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async assetCustomFieldValuesByAssetControllerDelete(requestParameters: AssetCustomFieldValuesByAssetControllerDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.assetCustomFieldValuesByAssetControllerDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async assetCustomFieldValuesByAssetControllerGetByAssetRaw(requestParameters: AssetCustomFieldValuesByAssetControllerGetByAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FindAssetCustomFieldValueResponseDto>>> {
        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling assetCustomFieldValuesByAssetControllerGetByAsset().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling assetCustomFieldValuesByAssetControllerGetByAsset().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/assets/{assetId}/custom-field-values`;
        urlPath = urlPath.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters['assetId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FindAssetCustomFieldValueResponseDtoFromJSON));
    }

    /**
     */
    async assetCustomFieldValuesByAssetControllerGetByAsset(requestParameters: AssetCustomFieldValuesByAssetControllerGetByAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FindAssetCustomFieldValueResponseDto>> {
        const response = await this.assetCustomFieldValuesByAssetControllerGetByAssetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async assetCustomFieldValuesByAssetControllerGetByIdRaw(requestParameters: AssetCustomFieldValuesByAssetControllerGetByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAssetCustomFieldValueResponseDto>> {
        if (requestParameters['valueId'] == null) {
            throw new runtime.RequiredError(
                'valueId',
                'Required parameter "valueId" was null or undefined when calling assetCustomFieldValuesByAssetControllerGetById().'
            );
        }

        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling assetCustomFieldValuesByAssetControllerGetById().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling assetCustomFieldValuesByAssetControllerGetById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/assets/{assetId}/custom-field-values/{valueId}`;
        urlPath = urlPath.replace(`{${"valueId"}}`, encodeURIComponent(String(requestParameters['valueId'])));
        urlPath = urlPath.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters['assetId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAssetCustomFieldValueResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async assetCustomFieldValuesByAssetControllerGetById(requestParameters: AssetCustomFieldValuesByAssetControllerGetByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAssetCustomFieldValueResponseDto> {
        const response = await this.assetCustomFieldValuesByAssetControllerGetByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async assetCustomFieldValuesByAssetControllerUpdateRaw(requestParameters: AssetCustomFieldValuesByAssetControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAssetCustomFieldValueResponseDto>> {
        if (requestParameters['valueId'] == null) {
            throw new runtime.RequiredError(
                'valueId',
                'Required parameter "valueId" was null or undefined when calling assetCustomFieldValuesByAssetControllerUpdate().'
            );
        }

        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling assetCustomFieldValuesByAssetControllerUpdate().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling assetCustomFieldValuesByAssetControllerUpdate().'
            );
        }

        if (requestParameters['updateAssetCustomFieldValueRequestDto'] == null) {
            throw new runtime.RequiredError(
                'updateAssetCustomFieldValueRequestDto',
                'Required parameter "updateAssetCustomFieldValueRequestDto" was null or undefined when calling assetCustomFieldValuesByAssetControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/assets/{assetId}/custom-field-values/{valueId}`;
        urlPath = urlPath.replace(`{${"valueId"}}`, encodeURIComponent(String(requestParameters['valueId'])));
        urlPath = urlPath.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters['assetId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateAssetCustomFieldValueRequestDtoToJSON(requestParameters['updateAssetCustomFieldValueRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAssetCustomFieldValueResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async assetCustomFieldValuesByAssetControllerUpdate(requestParameters: AssetCustomFieldValuesByAssetControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAssetCustomFieldValueResponseDto> {
        const response = await this.assetCustomFieldValuesByAssetControllerUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
